import { useEffect } from 'react';
import { Text } from '@cencosud-cencommerce/paris-uikit';

import { useAppDispatch } from '@/Application/Hooks/Redux';
import { setErrorFallback } from '@/modules/buy-now/infrastructure/slices/BuyNowSlice';
import { ConnectionDogIcon } from '@/modules/perseo-billing/ui/react/src';
import { useSendBuyNowPageVirtualErrorEvent } from '@/modules/shared/utils/gtmEvents/events/useSendBuyNowPageVirtualEvent';

const LABEL_ERROR_TITLE = 'Algo salió mal';
const LABEL_ERROR_MESSAGE =
  'Lo sentimos, tenemos problemas para mostrar la información. Por favor, inténtalo de nuevo o prueba más tarde.';

export const FallbackBuyNow = () => {
  const dispatch = useAppDispatch();
  useSendBuyNowPageVirtualErrorEvent();

  useEffect(() => {
    dispatch(setErrorFallback(true));
    return () => {
      dispatch(setErrorFallback(false));
    };
  }, [dispatch]);

  return (
    <div className="co-w-full tablet_w:co-max-w-[385px] co-h-full co-flex co-items-center co-justify-center">
      <div className="co-w-full co-flex co-flex-col co-items-center co-justify-center co-pt-14 co-gap-4 co-px-6">
        <ConnectionDogIcon width={160} height={160} />

        <Text variant="subtitle1" color="primary-500" weight={700}>
          {LABEL_ERROR_TITLE}
        </Text>

        <Text
          variant="body1"
          className="co-text-[#363F45] co-leading-5 co-text-body1 co-text-center"
        >
          {LABEL_ERROR_MESSAGE}
        </Text>
      </div>
    </div>
  );
};

FallbackBuyNow.displayName = 'FallbackBuyNow';

export default FallbackBuyNow;
